var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuturestep3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 20,
    viewBox: "0 0 41 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10H1",
    stroke: "#000",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.916 9.207h.814c.512-.008.915-.143 1.207-.404.293-.262.44-.616.44-1.06 0-1-.498-1.5-1.494-1.5-.469 0-.844.134-1.125.403-.277.266-.416.62-.416 1.061h-1.084c0-.676.246-1.236.738-1.682.496-.449 1.125-.673 1.887-.673.805 0 1.435.212 1.892.638.457.426.686 1.018.686 1.776 0 .37-.121.73-.363 1.078a2.158 2.158 0 01-.979.779c.469.148.83.395 1.084.738.258.344.387.764.387 1.26 0 .766-.25 1.373-.75 1.822-.5.45-1.15.674-1.951.674-.801 0-1.453-.217-1.957-.65-.5-.434-.75-1.006-.75-1.717h1.09c0 .45.146.809.439 1.078.293.27.686.404 1.178.404.523 0 .924-.136 1.2-.41.278-.273.417-.666.417-1.177 0-.497-.153-.877-.457-1.143-.305-.266-.744-.402-1.319-.41h-.814v-.885z",
    fill: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#000"
  })));
}
SvgFuturestep3.displayName = 'Futurestep3';
export default SvgFuturestep3;